<template>
  <div style="overflow:hidden">
    <div v-if="showActions" class="radish-actions">
      <slot name="actions"></slot>
      <div class="radish-act-grp" style="float:right;">
        <span>个性设置：</span>
        <!-- <div class="radish-btn radish-btn-primary" @click="showOrderDialog">调整列顺序</div>
        <div class="radish-btn radish-btn-primary" @click="showCellsDialog">隐藏/显示列</div> -->
        <div class="radish-btn radish-btn-primary" @click="showHeadOrderDialog">表头调整</div>
      </div>
    </div>
    <table class="a-table a-table-head" cellspacing="0" :style="{ width: tableWidth, left: tableHeadLeft }">
      <tr>
        <th style="width:55px"></th>
        <th v-if="checkable" style="width:30px">
          <input v-model="isCheckedAll" type="checkbox" @change="onCheckAll" />
        </th>
        <template v-for="head in heads">
          <th v-if="!head.hidden" :key="head.label + 'h'" :style="{ width: head.width + 'px' || '100px' }">
            {{ head.label }}
          </th>
        </template>
      </tr>
    </table>

    <div ref="scroller" class="a-table-layout" :style="layoutStyle" @scroll="onScroll">
      <table v-if="ready" class="a-table a-table-body" cellspacing="0" :style="{ width: tableWidth }">
        <tr style="height:0">
          <th style="width:55px"></th>
          <th v-if="checkable" style="width:30px"></th>
          <template v-for="head in heads">
            <th v-if="!head.hidden" :key="head.label" :style="{ width: head.width ? head.width + 'px' : '100px' }"></th>
          </template>
        </tr>
        <tr
          v-for="(item, index) in displayData"
          :key="'item' + start + index"
          :class="{ 'a-table-row-highlight': item.highlight || item.disable }"
          :style="trStyle(item)"
        >
          <td style="text-align:center">{{ start + index + 1 }}</td>
          <td v-if="checkable" style="text-align:center">
            <input v-model="displayData[index].checkedRow" type="checkbox" @change="onCheckOne(index)" :disabled="item.disable"/>
          </td>
          <template v-for="head in heads">
            <a-td
              v-if="!head.hidden"
              :key="head.label + start + index + 'b'"
              :head="head"
              :item="item"
              :index="index"
            ></a-td>
          </template>
        </tr>
        <tr v-if="tableLoading">
          <td :colspan="colspan">
            <el-button v-if="tableLoading" type="text" plain icon="el-icon-loading" style="width: 100vw"
              >加载中，请稍后</el-button
            >
          </td>
        </tr>
      </table>
    </div>
    <cellsDialog ref="cellsDialog" :on-confirm="setHiddenCell" :storage-name="storageName"></cellsDialog>
    <headOrderDialog ref="headOrderDialog"></headOrderDialog>
  </div>
</template>
<script>
import aTd from './a-td'
import cellsDialog from './cells-dialog'
import headOrderDialog from '../dialog/head-order-dialog'

export default {
  components: { aTd, cellsDialog, headOrderDialog },
  props: {
    heads: {
      // [{label:'姓名',field:'name',width:'100px',type:'text/link/tag/select/attach',content:'<i class="el-icon-setting">操作</i>',options:[],onClick:Function,onChange:Function,hidden:false}]
      type: Array,
      default: [],
    },
    data: {
      type: Array,
      default: [],
    },
    checkable: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
    },
    activeRowId: {
      type: String,
    },
    storageName: {
      type: String,
    },
    start: {
      type: Number,
      default: 0,
    },
    onSetHiddenCell: {
      type: Function,
      default: function() {},
    },
    onSetCellOrder: {
      type: Function,
      default: function() {},
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      ready: false,
      tableData: [],
      displayData: [],
      isCheckedAll: false,
      tableHeadLeft: 0,
      shiftKeyPressed: false,
      lastCheckIndex: '',
      tableLoading: false,
      scrolling: false,
    }
  },
  computed: {
    tableWidth: function() {
      let width = 60
      if (!this.checkable) {
        width = 30
      }
      this.heads.forEach(h => {
        if (!h.hidden) {
          h.width = h.width || 100
          width += h.width
        }
      })
      return `${width}px`
    },
    colspan: function() {
      return this.heads.filter(v => !v.hidden).length + 2
    },
    tableBottom: function() {
      return (this.tableData.length - this.displayData.length) * 30
    },
    layoutStyle: function() {
      if (this.height) {
        return { height: `${this.height}px` }
      }
    },
  },
  created() {
    this.shiftKeyDown = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = true)
      }
    }
    this.shiftKeyUp = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = false)
      }
    }
    document.addEventListener('keydown', this.shiftKeyDown)
    return document.addEventListener('keyup', this.shiftKeyUp)
  },
  destroyed() {
    document.removeEventListener('keydown', this.shiftKeyDown)
    return document.removeEventListener('keyup', this.shiftKeyUp)
  },
  methods: {
    trStyle: function(item) {
      const style = {}
      if (this.activeRowId == item._id) {
        style.backgroundColor = '#eef1f6'
      } else if (item['置顶']) {
        style.backgroundColor = '#ecf5ff'
      }
      // else if (!(localStorage.yxColorOff === 'true')) {
      //   if (item['意向'] == 'Y') {
      //     style.backgroundColor = '#ffe5e5'
      //   } else if (item['意向'] == 'N') {
      //     style.backgroundColor = '#ffffe1'
      //   } else if (item['意向'] == 'F') {
      //     style.backgroundColor = '#e5e5ff'
      //   }
      // }
      return style
    },
    onCheckAll: function() {
      this.tableData = this.tableData.map(dt => {
        if (!dt.disable) {
          dt.checkedRow = this.isCheckedAll
        }
        return dt
      })
    },
    onCheckOne: function(index) {
      if (this.lastCheckIndex !== '') {
        if (
          this.shiftKeyPressed &&
          this.tableData[index].checkedRow == this.tableData[this.lastCheckIndex].checkedRow
        ) {
          const big = Math.max(this.lastCheckIndex, index)
          const small = Math.min(this.lastCheckIndex, index)
          this.tableData = this.tableData.map((dt, i) => {
            if (i >= small && i <= big && !dt.disable) {
              dt.checkedRow = this.tableData[index].checkedRow
            }
            return dt
          })
        }
      }
      this.lastCheckIndex = index
    },
    getChecked: function() {
      return this.tableData.filter(dt => dt.checkedRow)
    },
    cancelChecked() {
      this.tableData.forEach(dt => {
        this.$set(dt, 'checkedRow', false)
      })
    },
    onScroll: function() {
      this.setDisplay()
      this.tableHeadLeft = `${-this.$refs.scroller.scrollLeft}px`
    },
    setDisplay: function(force) {
      if (!force && this.scrolling) return
      if (force || this.displayData.length < this.tableData.length) {
        const sTop = this.$refs.scroller.scrollTop
        this.ready = false
        this.tableData = this.data
        const dtLen = this.displayData.length
        const quaLen = this.tableData.length > 100 ? Math.floor(this.tableData.length * 0.4) : this.tableData.length
        const interLen = force ? quaLen : this.tableData.length - quaLen
        const tmpLen = force ? Math.floor(quaLen * 0.6) : Math.floor((this.tableData.length - quaLen) * 0.6)
        if (force || sTop > (dtLen - interLen + tmpLen) * 25) {
          this.tableLoading = true
          this.scrolling = true
          this.displayData = []
          this.displayData = this.tableData.slice(0, dtLen + interLen)
          this.$nextTick(v => {
            this.scrolling = false
          })
        }
        if (this.displayData.length === this.tableData.length) {
          this.tableLoading = false
        }
        this.isCheckedAll = false
        this.ready = true
      }
    },

    showCellsDialog: function() {
      const heads = this.heads.map(head => ({ label: head.label, hidden: head.hidden || false }))
      this.$refs.cellsDialog.show(heads)
    },
    showOrderDialog: function() {
      app.root.$refs.orderDialog.show({
        items: this.heads.map(h => h.label),
        storageName: this.storageName,
        onConfirm: () => {
          this.onSetCellOrder()
        },
      })
    },
    showHeadOrderDialog() {
      const heads = this.heads.map(head => ({ label: head.label, visible: !head.hidden }))

      this.$refs.headOrderDialog.show({
        heads,
        storageName: this.storageName,
        onConfirm: () => {
          this.onSetHiddenCell()
          this.onSetCellOrder()
        },
      })
    },
    setHiddenCell: function() {
      this.onSetHiddenCell()
    },
    reset: function() {
      this.ready = false
      this.isCheckedAll = false
      this.tableData = this.data
      this.displayData = this.tableData.slice(0, 80)
      this.ready = true
      this.$refs.scroller.scrollTop = 0
    },
    getTableData() {
      return this.tableData
    },
  },
}
</script>
<style>
.a-table {
  table-layout: fixed;
  border-left: 1px solid #eee;
  border-bottom: 1px solid #eee;
  color: #444;
  content-visibility: auto;
}
.a-table-head {
  position: relative;
}
.a-table-layout {
  position: relative;
  width: 100%;
  overflow: auto;
}
.a-table > tr > th {
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  box-sizing: border-box;
}
.a-table > tr > td {
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  box-sizing: border-box;
  height: 25px;
  position: relative;
}
/* .a-table>tr>td .el-select .el-input__suffix {
  display: none;
}
.a-table>tr>td .el-select .el-input__inner {
  padding-right: 0;
} */
.a-table > tr > td select {
  border: none;
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  text-align: center;
  text-align-last: center;
}
.a-table-body {
  position: relative;
  top: -4px;
}
.a-link {
  color: #0472c7;
  cursor: pointer;
}
.a-tag {
  background-color: rgba(64, 158, 255, 0.1);
  display: inline-block;
  padding: 0 5px;
  color: #0472c7;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid rgba(64, 158, 255, 0.2);
  white-space: nowrap;
  line-height: 1.2;
}
.cc-icon {
  display: inline-block;
  height: 14px;
  width: 14px;
  font-size: 12px;
  text-align: center;
  border-radius: 7px;
  line-height: 1;
  color: #fff;
}
.cc-icon-g {
  background-color: #ccc;
}
.cc-icon-r {
  background-color: #ffb5b0;
}
.cc-icon-y {
  background-color: #f8df9c;
}
.simi-icon {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  height: 14px;
  width: 12px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.icon-lightred {
  color: #f99;
}
.icon-red {
  color: #f66;
}
.icon-blue {
  color: #48a8ff;
}
.icon-grey {
  color: #ccc;
}
.a-table-row-highlight {
  background-color: #eef1f6;
}
.td-content {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 5px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 25px;
  z-index: 1;
}
.a-td-select {
  opacity: 0;
}
.a-td-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  cursor: pointer;
}
.a-tag.chushai-tag {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
  margin-left: 3px;
}
</style>
